import React, { useEffect } from "react"
import { Helmet } from "react-helmet"

import LayoutOrder from "../../../components/Layout/LayoutOrder"
import FormIframe from "../../../components/FormIframe"

export default function Page() {
  useEffect(() => {
    sessionStorage.setItem("firstURL", window.location.href)
  }, [])

  return (
    <LayoutOrder>
      <Helmet defer>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </Helmet>
      <FormIframe phoneValidate frame title="Оформите карту" buttonText="Оформить" />
    </LayoutOrder>
  )
}
